import { Super } from './super.model';

export class BlogCategory extends Super<BlogCategory> {

    public title: string;
    public description: string;
    
}
